/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
// TODO fix and remove eslint disables
import * as T from 'io-ts';
import { DateTime, Duration } from 'luxon';
export const ISOStringStorageLuxonDateTimeT = new T.Type('ISOStringStorageLuxonDateTimeT', (u) => u instanceof DateTime, (u, c) => {
    if (typeof u !== 'string') {
        return T.failure(u, c);
    }
    const result = DateTime.fromISO(u).toUTC();
    if (!result.isValid) {
        return T.failure(u, c);
    }
    return T.success(result);
}, 
// TODO cleanup this return, toISO apparently can return null
(a) => { var _a; return (_a = a.toUTC().toISO()) !== null && _a !== void 0 ? _a : ''; });
export const LuxonDurationT = new T.Type('LuxonDurationT', (u) => u instanceof Duration, (u, c) => {
    if (typeof u !== 'string') {
        return T.failure(u, c);
    }
    const result = Duration.fromISO(u);
    if (!result.isValid) {
        return T.failure(u, c);
    }
    return T.success(result);
}, 
// TODO cleanup this return, toISO apparently can return null
(a) => { var _a; return (_a = a.toISO()) !== null && _a !== void 0 ? _a : ''; });
